module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAYAAACJxx+AAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAdklEQVQY03XOsQ3CQBBE0XeGEDrADZB6A7qgEAjoARpAl0AXFHJ0Q4pEYpB1nCfcv/t3kpmUUjbIqQEWOOKMdarggBviO0sjWOGCA5bTo1RK2SOjb3XpRksyky4iHtjiine90Cp5xzB98UtEPLHDCa8/Q2XrkT9Lmh0vL7twZgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/personal_center/collection-left.png
// module id = Wg3F
// module chunks = 15